<template>
    <div class="entry_images">
        <form action="" method="post" enctype="multipart/form-data" :class="entry_uuid + 'file images_load mt-1'">
            <input type="file" name="files" class="files" :data-fileuploader-files='old_files' />
        </form>
    </div>
</template>

<script>
export default {
    props: ['preloadedfiles', 'entry_uuid', 'premium', 'copied_files'],
    data() {
        return {
            files: [],
            file_count: 0,
            old_files: "",
            similar: false,
            string_files: ""
        }
    },
    created() {
        this.create_files_upload();
        this.old_files = this.preloadedfiles;
        if (typeof this.old_files === 'string') {
            this.string_files = this.old_files
            this.copied_files ? this.similar = true : this.similar = false
        }
    },
    watch: {
        file_count() {
           if(this.file_count > 0) {
                this.$emit('file_count', this.file_count)
           }
        },
        string_files() {
            this.$emit('setFiles', this.string_files)
        },
        preloadedfiles() {
            this.old_files = this.preloadedfiles;
            if (typeof this.old_files === 'string') {
                this.similar = true
            }
        }
    },
    methods: {
        status_files(type) {
            if (type == "hide") {
                for (var i = 0; i < this.files.length; i++) {
                    this.files[i].html.find('.column-title span').html('Odstranenie...');
                    if (this.files[i].appended) {
                        axios.post('/api/offers/offer/entryImage/remove', {
                            item: this.files[i],
                            entry_uuid: this.entry_uuid
                        }).then(response => {
                            this.files.splice(i, 1)
                            i--
                            this.file_count--
                        })
                    } else {
                        const fd = new FormData();
                        fd.append('file', this.files[i].file);
                        fd.append('entry_uuid', this.entry_uuid);
                        axios.post('/api/offers/offer/entryImage/remove', fd).then(response => {
                            this.files.splice(i, 1)
                            i--
                            this.file_count--
                        })
                    }
                }
                this.old_files = null
            }
        },
        create_files_upload() {
            var t = this
            $(document).ready(function () {
                $.ajaxSetup({
                    headers: {
                        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
                    }
                });
                $("." + t.entry_uuid + "file.images_load input.files").fileuploader({
                    addMore: true,
                    limit: 10,
                    extensions: ["jpeg", "jpg", "png"],
                    fileMaxSize: 4,
                    changeInput: '<div class="fileuploader-input">' +
                        t.$t('offer.images_label') +
                        '<div class="fileuploader-input-inner">' +
                        '<div class="fileuploader-icon-main"></div>' +
                        '<h3 class="fileuploader-input-caption"><span>${captions.feedback}</span></h3>' +
                        "<p>${captions.or}</p>" +
                        "</div>" +
                        "</div>",
                    theme: "dragdrop",
                    thumbnails: {
                        item: '<li class="fileuploader-item">' +
                            '<div class="columns">' +
                            '<div class="column-thumbnail">' +
                            '${image}' +
                            '<span class="fileuploader-action-popup"></span>' +
                            '</div>' +
                            '<div class="column-title">' +
                            '<div title="${name}">${name}</div>' +
                            '<span>${size2}</span>' +
                            '</div>' +
                            '<div class="column-actions">' +
                            '<button type="button" class="fileuploader-action fileuploader-action-remove" title="${captions.remove}"><i class="fileuploader-icon-remove"></i></button>' +
                            '</div>' +
                            '${progressBar}' +
                            '</div>' +
                            '</li>',
                        item2: '<li class="fileuploader-item">' +
                            '<div class="columns">' +
                            '<div class="column-thumbnail">' +
                            '${image}' +
                            '<span class="fileuploader-action-popup"></span>' +
                            '</div>' +
                            '<div class="column-title">' +
                            '<div title="${name}">${name}</div>' +
                            '<span>${size2}</span>' +
                            '</div>' +
                            '<div class="column-actions">' +
                            '<button type="button" class="fileuploader-action fileuploader-action-remove" title="${captions.remove}"><i class="fileuploader-icon-remove"></i></button>' +
                            '</div>' +
                            '${progressBar}' +
                            '</div>' +
                            '</li>',
                        onImageLoaded: function (item) {
                            if (item.appended) {
                                t.file_count++;
                                t.files.push(item)
                                if (t.similar) {
                                    item.html.find('.column-title span').html('Nahrávanie...');
                                    const fd = new FormData();
                                    fd.append('file', item.file);
                                    fd.append('entry_uuid', t.entry_uuid);
                                    fd.append('similar', 1);
                                    axios.post('/api/offers/offer/entryImage/save', fd).then(
                                        response => {
                                            item.html.find('.column-title span').html(item
                                                .size2);
                                            t.string_files = JSON.stringify(response.data)
                                        })
                                }
                            } else {
                                item.html.find('.column-title span').html('Nahrávanie...');
                                const fd = new FormData();
                                fd.append('file', item.file);
                                fd.append('entry_uuid', t.entry_uuid);
                                fd.append('similar', 0);
                                axios.post('/api/offers/offer/entryImage/save', fd).then(
                                    response => {
                                        item.html.find('.column-title span').html(item
                                            .size2);
                                        t.file_count++;
                                        t.files.push(item)
                                        t.string_files = JSON.stringify(response.data)
                                    })
                            }
                            if (item.data.thumbnail) {
                                item.html.find('.fileuploader-no-thumbnail').html('<img src="' + item.data.thumbnail + '" style="width: 36px; height: 36px; object-fit: cover;" />');
                            }
                        },
                    },
                    editor: {
                        cropper: {
                            showGrid: true
                        }
                    },
                    captions: $.extend(true, {}, $.fn.fileuploader.languages["en"], {
                        feedback: t.$t('offer.images_upload_feedback'),
                        feedback2: t.$t('offer.images_upload_feedback'),
                        drop: t.$t('offer.images_upload_feedback'),
                        or: "",
                        button: "",
                        remove: t.$t('offer.images_remove'),
                        download: t.$t('offer.images_download'),
                        removeConfirmation: t.$t('offer.images_remove_confirm'),
                        errors: {
                            filesLimit: function (e) {
                                t.$toast.warning(
                                    t.$t('offer.images_only_ten'), {
                                    position: "top-right",
                                    timeout: 5000,
                                })
                            },
                            filesType: function (e) {
                                t.$toast.warning(
                                    t.$t('offer.images_invalid_type') + e
                                        .extensions + ".", {
                                    position: "top-right",
                                    timeout: 5000,
                                })
                            },
                            fileSize: function (e) {
                                t.$toast.warning(e.name +
                                    t.$t('offer.images_too_large_suffix') +
                                    e.fileMaxSize + " MB.", {
                                    position: "top-right",
                                    timeout: 5000,
                                })
                            }
                        }
                    }),
                    onRemove: function (item) {
                        item.html.find('.column-title span').html('Odstranenie...');
                        if (item.appended) {
                            axios.post('/api/offers/offer/entryImage/remove', {
                                item: item,
                                entry_uuid: t.entry_uuid
                            }).then(response => {
                                for (var i = 0; i < t.files.length; i++) {
                                    if (t.files[i] == item) {
                                        t.files.splice(i, 1)
                                        i--
                                        t.file_count--
                                    }
                                }
                            })
                        } else {
                            const fd = new FormData();
                            fd.append('file', item.file);
                            fd.append('entry_uuid', t.entry_uuid);
                            axios.post('/api/offers/offer/entryImage/remove', fd).then(
                                response => {
                                    for (var i = 0; i < t.files.length; i++) {
                                        if (t.files[i] == item) {
                                            t.files.splice(i, 1)
                                            i--
                                            t.file_count--
                                        }
                                    }
                                })
                        }
                    },

                });
            })
            //this.old_files = null
            this.similar = false
        }
    },
}
</script>
<style>
.loading-spinner {
    width: 36px;
    height: 36px;
    border: 3px solid rgba(0, 0, 0, 0.1);
    border-top: 3px solid #000;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>
<style lang="scss" scoped>
.info {
    position: absolute;
    top: 15px;
    right: 15px;
    margin-left: 8px;

    &:hover {
        .my_tooltip {
            opacity: 1;
        }
    }

    .info_icon {
        pointer-events: all;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        float: right;

        svg {
            width: 20px;
            height: 20px;
        }
    }

    .my_tooltip {
        pointer-events: none;
        opacity: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 250px;
        background: #F3385A;
        box-sizing: border-box;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
        border-radius: 5px;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 18px;
        text-align: center;
        color: #fff;
        padding: 10px;
        position: absolute;
        bottom: 25px;
        right: -5px;
        z-index: 10000;
        transition: opacity .5s ease-in-out;

        &::after {
            content: '';
            width: 15px;
            height: 15px;
            background: #F3385A;
            position: absolute;
            right: 8px;
            margin: auto;
            bottom: -3px;
            transform: rotate(45deg);
            border-radius: 3px;
        }
    }
}

.entry_images {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.pridat_obrazky_text {
    background-color: #fff;
    width: fit-content;
    padding: 0 10px;
    height: 40px;
    border-radius: 4px;
    font-family: Roboto;
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 15px;
    text-align: center;
    color: #212541;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    border: 0;
    cursor: pointer;
    border-bottom-width: 0px;
    border-bottom-style: none;
    border-bottom-color: currentcolor;
    border-bottom: 2px solid #fff;

    &.active {
        border-bottom: 2px solid #2ed8b6;
    }

    box-shadow: 0px 1px 1px 0px #00000024;
}
</style>
<style lang="scss">
.images_load {
    width: 500px;

    .fileuploader {
        background: transparent;
        margin: 0;
        padding: 0;
    }

    .fileuploader-theme-dragdrop .fileuploader-input {
        position: relative;
        border: 1px dashed #DDE3E8;
        padding: 15px;
        height: 91px;

        .top_left {
            position: absolute;
            left: 15px;
            top: 15px;
            font-family: Roboto;
            font-style: normal;
            font-weight: bold;
            font-size: 11px;
            line-height: 13px;
            letter-spacing: 0.1em;
            text-transform: uppercase;
            color: #9598A7;
        }

        .fileuploader-input-inner {
            margin-top: 14px;
            height: 100%;
            display: flex;
            align-items: center;
        }
    }

    .fileuploader-theme-dragdrop .fileuploader-input .fileuploader-icon-main {
        margin: 0;
        font-size: 32px;
    }

    h3.fileuploader-input-caption {
        margin: 0;
        display: block;
        flex: none;
        align-self: center;
        margin-left: 10px;
        font-family: Roboto;
        font-style: normal;
        font-size: 14px;
        line-height: 16px;

        span {
            font-weight: normal;
            color: #263544;
        }

        .nahraj {
            font-weight: 600;
            color: #2ED8B6;
            text-decoration: underline;
        }
    }
}
</style>
